import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import moment from 'moment';
import {
  ExternalServiceLogFilters,
  ExternalServiceLogService
} from '../../../services/external-service-log.service';

@Component({
  selector: 'app-external-service-logs-page',
  templateUrl: './external-service-logs-page.component.html',
  styleUrl: './external-service-logs-page.component.scss'
})
export class ExternalServiceLogsPageComponent {

  @ViewChild('dt') dt!: Table;

  public neighborhoodId: string = '';
  public isNeighborhoodContext: boolean = false;

  public first: number = 0;
  public rows: number = 25;

  public filterService: string | null = null;
  public filterDirection: string | null = null;
  public filterSuccess: string | null = null;
  public filterStartDate: Date | null = null;
  public filterEndDate: Date | null = null;

  public serviceOptions: { label: string; value: string }[] = [
    { label: 'Conekta', value: 'conekta' }
  ];

  public directionOptions: { label: string; value: string }[] = [
    { label: 'Saliente', value: 'outbound' },
    { label: 'Entrante', value: 'inbound' }
  ];

  public successOptions: { label: string; value: string }[] = [
    { label: 'Éxito', value: 'true' },
    { label: 'Error', value: 'false' }
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    public externalServiceLogService: ExternalServiceLogService
  ) {
    this.activatedRoute.params.subscribe(params => {
      if (params['neighborhoodId']) {
        this.neighborhoodId = params['neighborhoodId'];
        this.isNeighborhoodContext = true;
      }
    });
  }

  /*
  ██╗      ██████╗  █████╗ ██████╗     ██████╗  █████╗ ████████╗ █████╗
  ██║     ██╔═══██╗██╔══██╗██╔══██╗    ██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗
  ██║     ██║   ██║███████║██║  ██║    ██║  ██║███████║   ██║   ███████║
  ██║     ██║   ██║██╔══██║██║  ██║    ██║  ██║██╔══██║   ██║   ██╔══██║
  ███████╗╚██████╔╝██║  ██║██████╔╝    ██████╔╝██║  ██║   ██║   ██║  ██║
  ╚══════╝ ╚═════╝ ╚═╝  ╚═╝╚═════╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝

  */
  // region loadData
  async loadData(
    page: number,
    pageSize: number
  ): Promise<void> {
    const filters: ExternalServiceLogFilters = {};

    if (this.filterService) filters.service = this.filterService;
    if (this.filterDirection) filters.direction = this.filterDirection;
    if (this.filterSuccess !== null) filters.success = this.filterSuccess;
    if (this.filterStartDate) {
      filters.startDate = moment(this.filterStartDate).format('YYYY-MM-DD');
    }
    if (this.filterEndDate) {
      filters.endDate = moment(this.filterEndDate).format('YYYY-MM-DD');
    }
    if (
      this.isNeighborhoodContext &&
      this.neighborhoodId
    ) {
      filters.neighborhoodId = this.neighborhoodId;
    }

    await this.externalServiceLogService.getAll(
      filters,
      page,
      pageSize
    );
  }

  /*
   ██████╗ ███╗   ██╗██╗      █████╗ ███████╗██╗   ██╗██╗      ██████╗  █████╗ ██████╗
  ██╔═══██╗████╗  ██║██║     ██╔══██╗╚════██║╚██╗ ██╔╝██║     ██╔═══██╗██╔══██╗██╔══██╗
  ██║   ██║██╔██╗ ██║██║     ███████║    ██╔╝ ╚████╔╝ ██║     ██║   ██║███████║██║  ██║
  ██║   ██║██║╚██╗██║██║     ██╔══██║   ██╔╝   ╚██╔╝  ██║     ██║   ██║██╔══██║██║  ██║
  ╚██████╔╝██║ ╚████║███████╗██║  ██║   ██║     ██║   ███████╗╚██████╔╝██║  ██║██████╔╝
   ╚═════╝ ╚═╝  ╚═══╝╚══════╝╚═╝  ╚═╝   ╚═╝     ╚═╝   ╚══════╝ ╚═════╝ ╚═╝  ╚═╝╚═════╝

  */
  // region onLazyLoad
  onLazyLoad(event: TableLazyLoadEvent): void {
    this.first = event.first ?? 0;
    this.rows = event.rows ?? 25;
    const page = Math.floor(this.first / this.rows) + 1;
    this.loadData(page, this.rows);
  }

  /*
  ███████╗███████╗ █████╗ ██████╗  ██████╗██╗  ██╗
  ██╔════╝██╔════╝██╔══██╗██╔══██╗██╔════╝██║  ██║
  ███████╗█████╗  ███████║██████╔╝██║     ███████║
  ╚════██║██╔══╝  ██╔══██║██╔══██╗██║     ██╔══██║
  ███████║███████╗██║  ██║██║  ██║╚██████╗██║  ██║
  ╚══════╝╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝ ╚═════╝╚═╝  ╚═╝

  */
  // region search
  search(): void {
    this.first = 0;
    this.loadData(1, this.rows);
  }

}
